import { HStack, Tag, Text, useSelectContext } from '@chakra-ui/react';

import { Tooltip } from '../tooltip';

interface MultiValueDisplayProps {
  placeholder: string;
}

export const MultiValueDisplay = ({ placeholder }: Readonly<MultiValueDisplayProps>) => {
  const { value, setValue, disabled, collection } = useSelectContext();

  if (!Array.isArray(value) || value.length === 0) {
    return <Text color="gray.500">{placeholder}</Text>;
  }

  const handleRemove = (val: string) => {
    setValue(value.filter((v) => v !== val));
  };

  return (
    <HStack flexWrap="nowrap" gap={0.5} overflow="hidden" onClick={(e) => e.stopPropagation()}>
      {value.map((val) => {
        const label = collection.find(val)?.label ?? val;
        return (
          <Tag.Root key={val} size="sm" variant="dark" minWidth="0" flexShrink={1} cursor="default">
            <Tooltip content={label} openDelay={300}>
              <Tag.Label textOverflow="ellipsis">{collection.find(val)?.label ?? val}</Tag.Label>
            </Tooltip>
            <Tag.CloseTrigger
              as="div"
              marginLeft="auto"
              data-disabled={disabled}
              flexShrink={0}
              onClick={() => handleRemove(val)}
            />
          </Tag.Root>
        );
      })}
    </HStack>
  );
};
